import { colorLerp, lerp } from './Tools'

export default class Arc
{
    constructor({ radius, rotation, angle, weight })
    {
        const alignAngle = angle + Math.random() * Math.PI / 4
        const middleRotation = rotation + alignAngle / 2

        let alignRotation = rotation
        if (middleRotation < Math.PI / 2)
        {
            alignRotation = 0 - alignAngle / 2
        }
        else if (middleRotation < Math.PI * 3 / 2)
        {
            alignRotation = Math.PI - alignAngle / 2
        }
        else
        {
            alignRotation = 2 * Math.PI - alignAngle / 2
        }

        this._radius = radius
        this._rotations = {
            start: rotation - Math.PI / 2 + angle / 2,
            std1: rotation + Math.random() * Math.PI / 4,
            std2: rotation + Math.random() * Math.PI / 4,
            align: alignRotation
        }

        this._angles = {
            start: 0,
            std1: angle + Math.random() * Math.PI / 8,
            std2: angle + Math.random() * Math.PI / 8,
            align: alignAngle
        }

        this._weight = weight
        this._colors = {
            dark:  { r: 255, g: 255, b: 255, a: 0.01 },
            white: { r: 255, g: 255, b: 255, a: 0.5 },
            blue:  { r: 255, g: 255, b: 255, a: 0.05 }
        }
    }

    getRadius()
    {
        return this._radius
    }

    getRotation(fromType, toType, time, id = 0)
    {
        const fromLabel = fromType === Arc.TYPE_START ? 'start' : fromType === Arc.TYPE_STD ? 'std' + (1 + (id % 2)) : 'align'
        const toLabel = toType === Arc.TYPE_START ? 'start' : toType === Arc.TYPE_STD ? 'std' + (1 + ((id + 1) % 2)) : 'align'
        return lerp(this._rotations[fromLabel], this._rotations[toLabel], time)
    }

    getAngle(fromType, toType, time, id = 0)
    {
        const fromLabel = fromType === Arc.TYPE_START ? 'start' : fromType === Arc.TYPE_STD ? 'std' + (1 + (id % 2)) : 'align'
        const toLabel = toType === Arc.TYPE_START ? 'start' : toType === Arc.TYPE_STD ? 'std' + (1 + ((id + 1) % 2)) : 'align'
        return lerp(this._angles[fromLabel], this._angles[toLabel], time)
    }

    getWeight()
    {
        return this._weight
    }

    getColor(fromColor, toColor, time)
    {
        return colorLerp(this._colors[fromColor], this._colors[toColor], time)
    }
}

Arc.TYPE_START = 0
Arc.TYPE_STD = 1
Arc.TYPE_ALIGN = 2
